var spinData = {
  name: 'spin',
  data: [{
    size: 24,
    circleColor: '#29BECE',
    fontSize: 12
  }]
};
export default spinData;